import { DATA_SOURCES } from 'utils/metrics';
import NoDataSourceMarketCoverage from './NoDataSourceMarketCoverage';

function NoTikTokDataSection(props) {
    return (
        <NoDataSourceMarketCoverage
            dataSource={DATA_SOURCES.TIKTOK.key}
            {...props}
        />
    );
}

export default NoTikTokDataSection;
